import React, {useCallback, useContext, useRef} from 'react';
import UserContext from '../../common/UserContext.js';

// react strap
import {Col, Row} from 'reactstrap';

// components
import {PopoverContext} from '../LicenseDownload.js';
import {downloadLicenses} from '../../common/utilities.js';

// kendo react
import {Tooltip} from '@progress/kendo-react-tooltip';
import {Loader} from '@progress/kendo-react-indicators';

// multilingual
import {useLocalization} from '@progress/kendo-react-intl';
import {
    downloadThisLicenseKey,
    hostKey,
    loadingGenerationKey,
    mainMessages,
} from '../../../assets/text/MultilingualText.js';
import {DownloadIcon, InfoIcon, WarningErrorIcon} from "../../common/icons";


export const PanelBarHeader = (props) => {
    const {
        host,
        setIsLoading,
        handleBeforeUnload
    } = props
    const {
        accessToken,
        siteLanguageDefault
    } = useContext(UserContext);
    const localization = useLocalization();

    //Sets the popover reference based on mouse over
    const popoverRef = useRef(null);
    const {onMouseOver} = useContext(PopoverContext);

    const handleMouseOver = useCallback(() => {
        const icons = host.icons;
        onMouseOver({
            show: true,
            popoverRef: popoverRef,
            generalError: icons.generalError,
            networkError: icons.networkError,
            cloudAlert: icons.cloudAlert
        });
    }, [onMouseOver, host.icons]);

    const handleMouseOut = useCallback(() => {
        const icons = host.icons;
        onMouseOver({
            show: false,
            popoverRef: popoverRef,
            generalError: icons.generalError,
            networkError: icons.networkError,
            cloudAlert: icons.cloudAlert
        });
    }, [onMouseOver, host.icons]);

    return (
        <>
            <Row
                style={{
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                <Col
                    style={{
                        flex: '0 0 auto',
                        width: 'auto'
                    }}
                >
                    <div
                        className={"k-h5"}
                        style={{
                            color: 'white',
                            margin: '0'
                        }}
                    >
                        {localization.toLanguageString(hostKey, mainMessages[siteLanguageDefault][hostKey])} {host.host_id}
                    </div>
                </Col>
                <Col/>
                <Col>
                    <div
                        style={{
                            float: 'right'
                        }}
                    >
                        <div>
                            {host.icons.loading && (
                                <Tooltip
                                    anchorElement="pointer"
                                    showCallout={true}
                                    parentTitle={true}
                                    openDelay={0}
                                    filter={(e) => {
                                        const classNames = ['k-loader k-loader-md k-loader-primary k-loader-pulsing-2', 'k-loader-segment', 'k-loader-canvas'];
                                        if (classNames.includes(e.className)) {
                                            return true;
                                        }
                                    }}
                                >
                                    <div
                                        title={localization.toLanguageString(loadingGenerationKey, mainMessages[siteLanguageDefault][loadingGenerationKey])}
                                        style={{paddingBottom: '1px'}}
                                    >
                                        <Loader
                                            type={'pulsing'}
                                            style={{
                                                color: 'white'
                                            }}
                                        />
                                    </div>
                                </Tooltip>
                            )}
                            {host.icons.download && (
                                <Tooltip
                                    anchorElement="pointer"
                                    showCallout={true}
                                    parentTitle={true}
                                    openDelay={0}
                                >
                                    <div
                                        title={localization.toLanguageString(downloadThisLicenseKey, mainMessages[siteLanguageDefault][downloadThisLicenseKey])}
                                        onClick={() => {
                                            downloadLicenses([host['transaction_id']], accessToken, setIsLoading, handleBeforeUnload, 'EESOF_RENEWAL');
                                        }}
                                    >
                                        <DownloadIcon
                                            size={'medium'}
                                            style={{
                                                color: 'white',
                                                marginTop: '0.35rem',
                                                marginLeft: '0.35rem',
                                                marginRight: '0.35rem',
                                                cursor: 'pointer'
                                            }}
                                        />
                                    </div>
                                </Tooltip>
                            )}
                            {(host.icons.generalError || host.icons.networkError) && (
                                <div
                                    onMouseOver={handleMouseOver}
                                    onMouseOut={handleMouseOut}
                                    ref={popoverRef}
                                >
                                    <WarningErrorIcon
                                        size={'medium'}
                                        style={{
                                            color: 'var(--keysight-pink)',
                                            marginTop: '0.35rem',
                                            marginLeft: '0.35rem',
                                            marginRight: '0.35rem',
                                        }}
                                    />
                                </div>
                            )}
                            {host.icons.cloudAlert && (
                                <span
                                    style={{
                                        marginLeft: '0.35rem',
                                        marginRight: '0.35rem',
                                    }}
                                    onMouseOver={handleMouseOver}
                                    onMouseOut={handleMouseOut}
                                    ref={popoverRef}
                                >
                                    <InfoIcon
                                        size={'medium'}
                                        style={{
                                            color: 'white',
                                            marginTop: '0.35rem',
                                            marginLeft: '0.35rem',
                                            marginRight: '0.35rem',
                                            cursor: 'pointer'
                                        }}
                                    />
                                </span>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    )
}